import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ShareAmountService implements OnDestroy{
  private destroy$ = new Subject<void>();
  constructor() {}

  private _amountObs$ = new BehaviorSubject(null);
  private _valueObs$ = new BehaviorSubject(null);
  public cancelSubscription$ = new BehaviorSubject(null);

  setAmount(newValue: any): void {
    this._amountObs$.next(newValue);
  }

  get getAmountObs(): any {
    return this._amountObs$;
  }

  setObservableValue(newValue: any): void {
    this._valueObs$.next(newValue);
  }

  get getNewObservableValue(): any {
    return this._valueObs$;
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
